import CloneErrorComponent from "@ext/git/actions/Clone/error/components/CloneError";
import PushDeclinedByRemoteErrorComponent from "@ext/git/actions/Publish/error/components/PushDeclinedByRemoteError";
import { RepositoryHealthcheckError } from "@ext/git/actions/RepositoryBroken/RepositoryHealthcheckFailed";
import type { ComponentProps, ReactNode } from "react";
import type GetErrorComponent from "../../errorHandlers/logic/GetErrorComponent";
import CheckoutConflictErrorComponent from "../actions/Branch/error/components/CheckoutConflictError";
import GitErrorCode from "../core/GitCommands/errors/model/GitErrorCode";
import NotFoundErrorHandler from "./NotFoundErrorHandler";

const getGitErrors = (): {
	[key: string]: (args: ComponentProps<typeof GetErrorComponent>) => ReactNode;
} => ({
	[GitErrorCode.NotFoundError]: NotFoundErrorHandler,
	[GitErrorCode.CheckoutConflictError]: CheckoutConflictErrorComponent,
	[GitErrorCode.CloneError]: CloneErrorComponent,
	[GitErrorCode.RemoteRepositoryNotFoundError]: CloneErrorComponent,
	[GitErrorCode.HealthcheckFailed]: RepositoryHealthcheckError,
	[GitErrorCode.PushDeclinedByRemoteError]: PushDeclinedByRemoteErrorComponent,
});

export default getGitErrors;
